import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'cmg-clear2-ui-unsaved-refresh-confirmation',
  templateUrl: './unsaved-refresh-confirmation.component.html',
  styleUrls: ['./unsaved-refresh-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective],
})
export class UnsavedRefreshConfirmationComponent {
  private readonly _dialogRef = inject(DynamicDialogRef);

  cancel(): void {
    this._dialogRef.close(false);
  }

  refresh(): void {
    this._dialogRef.close(true);
  }
}
